import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Input } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService } from '../../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';

import { WhiteBoardComponent } from "../white-board.component";
import { SessionManagerService } from "../services/session/session-manager.service";
import { RecordingManagerService } from "../services/recording/recording-manager.service";
import { LayoutManagerService } from "../services/layout/layout-manager.service";
import {LogService} from "../services/log/log.service";

import { PermissionsManagerService } from "../services/permissions/permissions-manager.service";
declare var $;
declare var MQ;
declare var JXG;
@Component({
  selector: "dskl-wb-geometry",
  templateUrl: 'geometry-wb.component.html',
  inputs: ["board"],
  outputs: ["change"]
})

export class GeometryWbComponent extends WhiteBoardComponent {


  @ViewChild('box') box: ElementRef;
  @Input() boards;

  onReady() {

    this.wbService.registerForMathRow(this);
    this.translatePageName();
  }
 
  onResize() {
    var a = this.resize();
    this.setBouningBox(a);
  }
  onCurrentPageState(state, pageId) {
    console.log("WIll set current state", state)
    if (!state) return;
    // state = JSON.parse(state);
    this.stateElements = state;
    for (let id in state) {
      var o = state[id]
      console.log("Adding ", o);
      switch (o.type) {
        case "circle":
        case "line":
          for (let pid in o.points) {
            this._addForm(o.points[pid], o.type, 2, false, id);

          }; break;
        case "triangle":
        case "polygon":
          var off = 1;
          for (let pid in o.points) {
            if (off++ == o.points.length) {
              this.lastOverElement = this.currentPointsForForm[0];
            }

            this._addForm(o.points[pid], o.type, 0, false, id);
          }
          break
        case "point": //this.addPoint(o.points, false); break;
      }
      /*   var t = this.jxboard.create(o.type, o.points, o.type!="POINT"?{ hasInnerPoints: true }:{});
      this.addId(t, id);
      this.stateElements[t.dsklid]={type: o.type, points: o.points};
      this.registerUp(t);
      if (o.type=="POINT"){
        this.registerPointForDown(t)
      }*/

    }
    /*for (let a in arr){
    this.jxboard.objectsList.push(arr[a]);
    }
    this.jxboard.update()
    /*this.jxboard.jc.parse(state.state);
    for (let o of this.jxboard.objectList){
      
      this.registerUp(o)
    }*/
  }
  getCurrentState() {
    console.log(this.stateElements)
    return this.stateElements;
    /*
    console.log("Will get curren tstate");
    for (let e in this.elements){
      var s = JSON.stringify(this.elements[e]);
      console.log(s);
      
    }


    var state = JXG.Dump.toJessie(this.jxboard);
    console.log(state);
    return {state:state};*/
  }


  translatePageName() {
    this.translate.get('WB_PAGE_NAME.PAGE_GEOMETRY').subscribe((res: string) => { this.pageName = res; });
  }
  getWbType() {
    return this.pageName;
  }
  pageName = "Дъска за геометрия"
  constructor(protected log: LogService, protected wbService: WbService, private wsService: WsService, private translate: TranslateService, protected sessionManager: SessionManagerService, protected layoutManagerService: LayoutManagerService, protected permissionsManager: PermissionsManagerService) {
    super(log, wbService, sessionManager, layoutManagerService, permissionsManager);
  }

  clearStates() {
    if (this.jxboard) {
      JXG.JSXGraph.freeBoard(this.jxboard);
    }
    this.onViewReady();
  }
  jxboard;
  addPerpendiculiar(border, pointName) {
    var cerise = {
      strokeColor: '#901B77',
      fillColor: '#CA147A'
    };
    var perpendicular = {
      strokeColor: 'black',
      dash: 1,
      strokeWidth: 1,
      point: JXG.deepCopy(cerise, {
        visible: true,
        withLabel: true
      })
    };
    return this.jxboard.create('perpendicular', [border, pointName], perpendicular);
  }

  private degrees(rads) {
    return (180 / Math.PI * rads).toFixed() + "°";

  }
  private addAngle(r, c, l) {
    var a = this.jxboard.create('angle', [l, c, r], { type: 'sector', orthoType: 'sectordot', orthoSensitivity: 2, radius: 1 });
    var self = this;
    c.on("drag", function () {

      self.updateAngle(a);
    });
    this.updateAngle(a);

    this.lastangles.push(a);
    return a;
  }
  private updateAngle(a) {

    a.setLabelText(this.degrees(a.Value()));
  }
  lastbisectors = [];
  _bisectors(e) {
    if (this.justRemovedPolygonDetails(this.lastbisectors)) {
      this.lastbisectors = [];
    } else {
      this.addPolygonDetails(e, "bisector");
    }
  }
  bisectors() {

    this.changed("polygon-details", { id: this.lastElement.dsklid, type: "bisectors" });
    this._bisectors(this.lastElement);
  }
  private justRemovedPolygonDetails(array) {
    console.log(array.length);
    if (array.length > 0) {
      for (var m of array) {
        this.removeElement(m);
      }
      return true;
    }
    return false;
  }
  private addPolygonDetails(e, type) {
    var vs = e.vertices;
    for (let i = 0; i < vs.length - 1; i++) {
      let a = i % (vs.length - 1);
      let b = (i + 1) % (vs.length - 1);
      let c = (i + 2) % (vs.length - 1);
      switch (type) {
        case "median":
          this.addMedian(vs[a], vs[b], vs[c]);
          break;
        case "bisector":
          this.addBisector(vs[a], vs[b], vs[c]);
          break
        case "angle":
          this.addAngle(vs[a], vs[b], vs[c]);
          break;
      }

    }
  }
  _medians(e) {
    if (this.justRemovedPolygonDetails(this.lastmedians)) {
      this.lastmedians = [];
    } else {
      this.addPolygonDetails(e, "median");
    }
  }
  medians() {
    this.changed("polygon-details", { id: this.lastElement.dsklid, type: "medians" });
    this._medians(this.lastElement);
  }
  lastangles = [];
  _angles(e) {
    if (this.justRemovedPolygonDetails(this.lastangles)) {
      this.lastangles = [];
    } else {
      this.addPolygonDetails(e, "angle");
    }
  }
  angles() {
    this.changed("polygon-details", { id: this.lastElement.dsklid, type: "angles" });
    this._angles(this.lastElement);
  }
  addMedian(opositeP1, opositeP2, p) {
    var cerise = {
      strokeColor: '#901B77',
      fillColor: '#CA147A'
    };
    var median = {
      strokeWidth: 1,
      strokeColor: '#CA147A',
      dash: 2
    };
    var m = this.jxboard.create('midpoint', [opositeP1, opositeP2], cerise);
    var s = this.jxboard.create('segment', [m, p], median);
    this.lastmedians.push(m);
    this.lastmedians.push(s);

  }
  lastmedians = [];
  lastperpendiculiars = [];
  _ps(e) {
    if (this.lastperpendiculiars.length > 0) {
      for (var o of this.lastperpendiculiars) {
        o.remove();
      }
      this.lastperpendiculiars = [];
      return;
    }
    var grass = {
      strokeColor: '#009256',
      fillColor: '#65B72E',
      visible: true,
      withLabel: true,
      name: "H"
    }
    var a = this.addPerpendiculiar(e.borders[0], e.vertices[2]);
    var b = this.addPerpendiculiar(e.borders[1], e.vertices[0]);
    var c = this.addPerpendiculiar(e.borders[2], e.vertices[1]);

    var h = this.jxboard.create('intersection', [a, b, c], grass);
    this.lastperpendiculiars.push(a);
    this.lastperpendiculiars.push(b);
    this.lastperpendiculiars.push(c);
    this.lastperpendiculiars.push(h);
  }
  perpendiculiars() {
    this.changed("polygon-details", { id: this.lastElement.dsklid, type: "perpendiculiars" });
    this._ps(this.lastElement);
  }
  addBisector(l, c, r) {
    var bisector = {
      strokeWidth: 1,
      strokeColor: '#0000ff',
      dash: 2
    };
    var l1 = this.jxboard.create('bisector', [l, c, r], bisector); // alpha
    this.lastbisectors.push(l1);
  }
  setPointPosition(p, coords) {

    if (p) {
      if (p.coords.usrCoords[0] != coords[0] || p.coords.usrCoords[1] != coords[1]) {
        p.setPosition(JXG.COORDS_BY_USER, coords);
        this.jxboard.update();
      }
    }
  }
  hasAlgebra() {
    if (this.boards.length == 1) return false;
    for (var b of this.boards)
      if (b.wbType == 'ALGEBRA') return true
    return false;
  }
  private resize() {
    console.log("Resizing")
    var h = window.innerHeight - this.getResizeTopOffset() - this.getResizeBottomOffset();

    // var h = $("body").height() - (!this.topLayout ? $("#videos").height() : 0) - 80;
    $("#box").css("height", h);
    var w = $("body").width() ;
    if (this.boards.length == 2) {
      w = w / 2;
    }
    $("#box").css("width", w);
    return w / h

  }
  private getBoundingBox(a) {
    return [-10 * a, 10, 10 * a, -10]
  }
  private setBouningBox(a) {
    this.jxboard.setBoundingBox(this.getBoundingBox(a))
  }
  onViewReady() {
    var a = this.resize();
JXG.Options.text.useMathJax = true;
    this.jxboard = JXG.JSXGraph.initBoard('box', { showCopyright: false, boundingbox: this.getBoundingBox(a), axis: true });
    var self = this;
    
    this.jxboard.on("up", function (e) {
      self.onMouseUp(this.getUsrCoordsOfMouse(e));
    });
    this.jxboard.on("boundingbox", function (e) {
      console.log(this);
      console.log(this.getBoundingBox());

    });


  }

  del() {
    if (this.lastElement) {
      this.deleteElement(this.lastElement.dsklid);
      this.changed("delete", { id: this.lastElement.dsklid });


      this.tool("select");
    }
  }
  removeElement(p) {
    if (!p) return;
    p.remove();
    console.log("trying to delete ", p.id)
    this.jxboard.removeObject(p)
    this.jxboard.update();

    if (p.dsklid && this.elements[p.dsklid])
      delete this.elements[p.dsklid];
  }
  tool(t) {
    this.lastElement = null;
    this.lastTool = t
    for (var p of this.currentPointsForForm)
      this.removeElement(p);
    this.currentPointsForForm = [];
    if (t == "function") {
      this.changed("tool-function");
      this.addFunction("dsf");
    }
  }
  toolSelected(t) {
    return this.lastTool == t;
  }
  lastElement;
  elements = {};
  addId(p, idd = null) {
    var id;
    if (!idd) {
      do {
        id = this.wsService.userHash + Math.random();
      } while (this.elements[id]);
    }
    else {
      id = idd;
    }
    p["dsklid"] = id;
    this.elements[id] = p;
  }
  stateElements = {};
  private registerPointForDown(p) {
    var self = this;
    p.on("down", function () {
      console.log("ADdng position on down", this.coords.usrCoords);
      self.points[p.dsklid] = this.coords.usrCoords.slice();
    });
  }
  private createPoint(coords, id = null) {
    var p = this.jxboard.create('point', coords);

    this.addId(p, id);

    this.registerUp(p);

    this.registerPointForDown(p)
    return p;
  }
  addPoint(coords, notify = true) {
    var p = this.createPoint(coords);
    this.registerOver(p);
    this.setLastElement(p);

    if (notify) {
      this.sendCreatePoint(p);
    }
    //this.stateElements[p.dsklid]={type: 'circle', points: [coords]};

    return p;
  }
  private getPointsForSend(ps) {
    var points = [];
    for (var p of ps) {
      points.push(this.getPointForSend(p));

    }
    return points;
  }
  private getPointForSend(p) {
    var coords = p.coords.usrCoords.slice(1, 3);

    return { type: "point", id: p.dsklid, coords: coords };
  }
  sendCreatePoint(p) {
    this.changed("add", this.getPointForSend(p));
  }
  sendUpdatePoint(p) {
    if (!this.points[p.dsklid] || (this.points[p.dsklid][0] != p.coords.usrCoords[0] ||
      this.points[p.dsklid][1] != p.coords.usrCoords[1]))
      this.changed("update", this.getPointForSend(p));
  }
  points = [];
  registerUp(o) {
    var self = this;
    o.on("up", function () {
      console.log("selected ", this);
      self.setLastElement(this);
      self.elementUpdated(this);
    })

  }
  elementUpdated(o) {
    console.log("Elemenet was updated ", o)

    var points = [];
    switch (o.elType) {
      case "point":
        this.sendUpdatePoint(o);
        break;

      case "polygon":
        var vertices = o.vertices;
        this.addStateElement(o.dsklid, "polygon", vertices);
        for (var v of o.vertices) {
          this.sendUpdatePoint(v);

        }
        break;
      case "line":
        this.addStateElement(o.dsklid, "line", [o.point1, o.point2]);
        this.sendUpdatePoint(o.point1);
        this.sendUpdatePoint(o.point2);

        break;
      case "circle":
        this.addStateElement(o.dsklid, "circle", [o.midpoint, o.point2]);
        this.sendUpdatePoint(o.midpoint);
        this.sendUpdatePoint(o.point2);


        break;
    }

  }
  registerOver(o) {
    var self = this;
    o.on("over", function () {
      self.setLastOverElement(this);
    })
  }
  setLastElement(t) {
    this.lastElement = t;
  }
  setLastOverElement(t) {
    this.lastOverElement = t;
  }

  lastOverElement;
  functions={};
  onMathRow(w, r){
    var f = this.addFunction(w);
    if (this.functions[r]){
      this.removeElement(this.functions[r]);
    }
    this.functions[r]=f;
  }
  addFunction(f){
    JXG.Options.text.useMathJax = true;
    var f = this.jxboard.jc.snippet(f, true, 'x', true);
   try{
    var o = this.jxboard.create('functiongraph', [f]);
    this.jxboard.update();
    this.addId(o);
  }catch(err){
    console.log(err);
  }
   return o;
  }
  addLine(coords) {
    var o = this._addForm(coords, 'line', 2);
    if (o) {

      this.addStateElement(o.dsklid, "line", [o.point1, o.point2]);
      this.changed("add", { type: "line", id: o.dsklid, points: this.getPointsForSend([o.point1, o.point2]) })
    }

  }

  private createForm(type, points, id = null) {
    var t = this.jxboard.create(type, points, { hasInnerPoints: true });
    this.addId(t, id);

    this.registerUp(t);

    return t;
  }
  _addForm(coords, type, points = 0, notify = true, id = null) {
    if (type != 'polygon')
      this.currentPointsForForm.push(this.addPoint(coords, notify));
    if ((type == 'polygon' && (this.currentPointsForForm.length > 2 && this.lastOverElement == this.currentPointsForForm[0]))
      || (type != 'polygon' && this.currentPointsForForm.length == points)) {
      var t = this.createForm(type, this.currentPointsForForm, id);//this.jxboard.create(type, array, {hasInnerPoints: true});
      this.setLastElement(t);
      this.currentPointsForForm = [];
      this.tool('select');

      return t;
    }
    if (type == 'polygon')
      this.currentPointsForForm.push(this.addPoint(coords, notify));

    return null;
  }
  currentPointsForForm = []
  addCircle(coords) {
    var o = this._addForm(coords, 'circle', 2);
    if (o) {

      this.addStateElement(o.dsklid, "circle", [o.midpoint, o.point2]);

      this.changed("add", { type: "circle", id: o.dsklid, points: this.getPointsForSend([o.midpoint, o.point2]) })
    }

    //var ci = this.jxboard.create('circle',coord, {strokeColor:'#00ff00',strokeWidth:2});
  }

  addPolygon(coords) {
    var o = this._addForm(coords, 'polygon');
    if (o) {
      var l = o.vertices.length;
      var vertices = o.vertices.slice(1, l);
      this.addStateElement(o.dsklid, "polygon", o.vertices);
      this.changed("add", { type: "polygon", id: o.dsklid, points: this.getPointsForSend(vertices) })
      return;
    }
    //this.currentPointsForForm.push(this.addPoint(coords));

  }
  addStateElement(id, type, points) {
    var ps = [];
    for (let p of points) {
      ps.push(p.coords.usrCoords.slice(1, 3));
    }
    if (!this.stateElements) this.stateElements = {};
    this.stateElements[id] = { type: type, points: ps };
  }

  lastTool;
  onMouseUp(coords) {
    switch (this.lastTool) {
      case "point": this.addPoint(coords, true);

        break;
      case "triangle": this.addPolygon(coords); break;
      case "polygon": this.addPolygon(coords); break;
      case "circle": this.addCircle(coords); break;
      case "line": this.addLine(coords); break;
      default: break;
    }
  }
  changing: boolean = false;
  onState(state, pageId) {
    if (pageId != this.board.pageId) {
      console.log("Not for me " + this.board.pageId + " but for " + pageId);
      console.log(state);
      return;
    }
    console.log(state);
    var o = state;

    try {
      switch (o.type) {
        case "add":
          if (this.elements[o.value.id]) return;
          switch (o.value.type) {
            case "point":
              this.createPoint(o.value.coords, o.value.id);
              break;
            case "circle":
              var points = this.getPointsFromState(o.value.points);
              this.createForm('circle', points, o.value.id);
              break;
            case "polygon":
              var points = this.getPointsFromState(o.value.points);
              this.createForm("polygon", points, o.value.id);
              break;
            case "line":
              var points = this.getPointsFromState(o.value.points);
              this.createForm("line", points, o.value.id);
              break;
          } break;

        case "update":

          this.setPointPosition(this.getPointById(o.value.id), o.value.coords);
          break;
        case "delete":
          this.deleteElement(o.value.id);
          break;
        case "polygon-details":

          var p = this.elements[o.value.id];
          if (p) {
            switch (o.value.type) {
              case "perpendiculiars": this._ps(p); break;
              case "medians": this._medians(p); break;
              case "bisectors": this._bisectors(p); break;
              case "angles": this._angles(p); break;
            }
          }

          break;
        case "tool-function":
          this.lastTool = "function";
          break;
      }
    } catch (error) {
      console.error(error);
    }
    this.jxboard.update();
  }
  private removeElements(ps) {
    for (var p in ps) {
      var o = ps[p]
      this.removeElement(o);
    }
  }
  private deleteElement(id) {
    var p = this.elements[id];
    if (p) {
      switch (p.elType) {
        case 'polygon': this.removeElements(p.vertices); break;
        case 'circle': this.removeElements([p.midpoint, p.point2]); break;
        case 'line': this.removeElements([p.point1, p.point2]); break;
      }

      this.removeElement(p);
      delete this.stateElements[id]
    }
  }
  private getPointById(id) {
    return this.elements[id];
  }
  private getPointsFromState(ps) {
    var points = [];
    for (var p of ps) {
      points.push(this.getPointById(p.id));
    }
    return points;
  }
  private changed(type, value = null) {
    this.emitChanged({ type: type, value: value });
  }
  hasPerpendiculiars() {
    return this.lastElement && this.lastElement.elType == "polygon" && this.lastElement.vertices.length == 4;
  }
  hasMedians() {
    return this.lastElement && this.lastElement.elType == "polygon";
  }
  hasAngles() {
    return this.lastElement && this.lastElement.elType == "polygon";
  }
  hasBisectors() {
    return this.lastElement && this.lastElement.elType == "polygon";
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/geometry/geometry-wb.component.ts